import { cloneDeep } from "lodash";
import { Template } from "../../common/types/Template";
import { SvodDohFilterSettings } from "./settings/SvodDohFilterSettings";
import { Classificator } from "../../common/types/Classificator";
import { allClassificationTypesOptions, allDataSourcesOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allStatusOptions, allBudgetTypesOptions, allMutuallyRedeemingOptions, allMutuallyRedeemingLevelOptions, allSegmentationOptions, allMeasureUnitsOptions } from "../../common/baseOptions";
import { SvodDohFilterOptions } from "./options/SvodDohFilterOptions";
import { ByForm } from "../../common/types/roots/fields";
import { Option } from "../../common/types/Option";

export const allSvodDohIncomeClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

export const SvodDohByFormOptions: Option<ByForm>[] = [
    { value: 'SVOD-DOH', label: 'Отчет о поступлении доходов', labelKk: 'Кірістердің түсуі туралы есеп', labelEn: 'Report on revenue receipts' }
]

const tempSettings: SvodDohFilterSettings = {
    // Base:
    reportName: 'SVOD-DOH',
    reportType: 'REGULATED',
    classificationType: 'INCOMES',
    dataSource: 'IISK',
    periodicity: 'DAY',
    mutuallyRedeeming: 'WITHOUT',
    byForm: 'SVOD-DOH',
    region: '',
    statuses: ['39'],
    incomes: cloneDeep(allSvodDohIncomeClassificators),
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    date: '',
    budgetTypes: [],
    mutuallyRedeemingLevels: [],
    onlyCurrentYearKbk: true,
    treeView: true,
    fillKbk: false,
    segmentations: [],
}

export const svodDohBaseTemplate: Template = {
    id: null,
    name: 'Отчет о поступлении доходов',
    excelName: null,
    description: null,
    category: '100',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const svodDohFilterOptions: SvodDohFilterOptions = {
    // Base:
    key: 'SVOD-DOH',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => ['IISK', 'LOADER'].includes(it.value))),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    regions: [],
    statuses: cloneDeep(allStatusOptions),
    incomes: cloneDeep(allSvodDohIncomeClassificators),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    segmentations: cloneDeep(allSegmentationOptions).filter(it => it.value !== 'GU'),
    byForms: cloneDeep(SvodDohByFormOptions),
}
